import { QueryClient } from '@tanstack/react-query'
import { CustomEvents } from 'shared/constants/customEvents'
import { FEATURE_FLAGS } from 'shared/constants/featureFlags'
import { SessionStorageKey } from 'shared/constants/sessionStorage'
import { dispatchCustomEvent } from 'shared/utils/customEvents'

import { CHECK_TOKEN_QUERY_KEY } from '../requests'
import { LoginResponse } from '../requests'

export const onLoginSuccess = (
  data: LoginResponse,
  queryClient: QueryClient,
  isOtpLogin: boolean = false,
  customRedirectRoute?: string
) => {
  let nextRoute = sessionStorage.getItem(SessionStorageKey.POST_LOGIN_REDIRECT)
  if (nextRoute && isOtpLogin) {
    sessionStorage.removeItem(SessionStorageKey.POST_LOGIN_REDIRECT)
  } else {
    nextRoute = '/'
  }
  const redirectRoute =
    customRedirectRoute ?? (isOtpLogin ? nextRoute : '/2fa-setup')

  dispatchCustomEvent(CustomEvents.AUTH_TOKEN_UPDATED, {
    access_token: data.access_token,
    refresh_token: data.refresh_token,
    redirectRoute
  })

  sessionStorage.removeItem(SessionStorageKey.OTP_LOGGING_IN_EMAIL)
  sessionStorage.removeItem(SessionStorageKey.OTP_LOGGING_IN_PASSWORD)
  if (FEATURE_FLAGS.SHOW_REMEMBER_ME) {
    sessionStorage.removeItem(SessionStorageKey.OTP_LOGGING_IN_REMEMBER_ME)
  }

  queryClient.invalidateQueries({
    queryKey: [CHECK_TOKEN_QUERY_KEY],
    exact: false
  })
}
